import {Injectable} from '@angular/core';
import {Backend} from '@generated-backend-types';
import {BaseEndpointService} from '../base-endpoint-service';
import TimeTrackingOverviewEntry = Backend.App.Resources.Dashboard.TimeTracking.TimeTrackingOverview.TimeTrackingOverviewEntry;

@Injectable({providedIn: 'root'})
export class TimeTrackingOverviewEntryService extends BaseEndpointService<TimeTrackingOverviewEntry> {
  protected override endpoint = '/time-tracking/overview/entries';
  protected override multiSelectTextFields = ['id'] as const;
}
